// extracted by mini-css-extract-plugin
export var border = "_a-7";
export var brand = "_a-s";
export var button = "_a-k";
export var center = "_a-9";
export var centered = "_a-5";
export var closeButton = "_a-b";
export var disabledWrapper = "_a-l";
export var error = "_a-o";
export var extraLarge = "_a-4";
export var extraSmall = "_a-1";
export var fill = "_a-h";
export var footer = "_a-g";
export var footerAction = "_a-i";
export var footerButtons = "_a-j";
export var header = "_a-6";
export var headerWithClose = "_a-c";
export var icon = "_a-n";
export var info = "_a-r";
export var inline = "_a-8";
export var large = "_a-3";
export var main = "_a-d";
export var modal = "_a-0";
export var neutral = "_a-t";
export var noPadding = "_a-f";
export var none = "_a-u";
export var scrollable = "_a-e";
export var small = "_a-2";
export var success = "_a-q";
export var tight = "_a-m";
export var titleIcon = "_a-a";
export var warn = "_a-p";